import { useEffect, useState } from "react";

const POLL_INTERVAL = 100;

/**
 * Polls for `window.d3` availability.
 *
 * d3 is loaded asynchronously via a Next.js `<Script strategy="afterInteractive">`
 * in layout.tsx. Chart components that depend on `window.d3` should gate their
 * rendering on this hook's return value to avoid racing the CDN script load.
 *
 * @returns `true` once `window.d3?.select` is available, otherwise `false`.
 */
const isD3Ready = () => !!(window as any)?.d3?.select;

export const useD3Ready = (): boolean => {
  const [ready, setReady] = useState(isD3Ready);

  useEffect(() => {
    if (ready) {
      return;
    }
    const timer = setInterval(() => {
      if (isD3Ready()) {
        setReady(true);
        clearInterval(timer);
      }
    }, POLL_INTERVAL);
    return () => clearInterval(timer);
  }, [ready]);

  return ready;
};
